module.exports = __webpack_public_path__ + "static/media/storyIconBlank.b51b8985.png";